import React from 'react';
// import TaxonomySelection from '../../helper/taxonomySelection';
// import MetadataSelection from '../../helper/metadataSelection';
import { findIndex } from 'underscore';
import clone from 'clone';
import BuildActions from '../../builder/action/builderActions';
import panelActions from '../action/panelActions';
import ReactToggle from 'react-toggle';
import { stringify } from '../../helper/helperFunction';

class ResetButtonPanel extends React.Component {
    constructor(props) {
      super(props);
      this.metakey = '_reactive_builder_' + this.props.shortcodeKey;
      this.saveData = this.saveData.bind(this);
      this.settings = {};
    }
    componentWillMount() {
      const allLayout = clone(this.props.allLayout);
      const index = findIndex(allLayout, { uid: this.props.uid });
      if (index !== -1) {
        const indexOfReset = findIndex(allLayout[index].searchAttr, { viewType: 'reset' });
        if(indexOfReset !== -1) {
          this.settings.buttonstyle = allLayout[index].searchAttr[indexOfReset].buttonstyle;
          this.settings.buttontitle = allLayout[index].searchAttr[indexOfReset].buttontitle;
          this.settings.dynamicNameClassScrollBox = allLayout[index].searchAttr[indexOfReset].dynamicNameClassScrollBox;
        }
      }
      this.setState({
        'settings': { ...this.settings },
      });
    }
    componentWillReceiveProps(nextProps) {
      if (nextProps.childUid !== this.props.childUid) {
        this.setState({
          'settings': { ...nextProps.settings },
        });
        this.settings = {};
      }
    }
    handelButtonTitle(e) {
      this.settings.buttontitle = e.target.value;
      this.setState({
        settings: { ...this.settings },
      });
    }
    handelButtonStyle(e) {
      this.settings.buttonstyle = e.target.value;
      this.setState({
        settings: { ...this.settings },
      });
    }
    handleClassName(e) {
      this.settings.dynamicNameClassScrollBox = e.target.value;
      this.setState({
        settings: { ...this.settings },
      });
    }
    saveData(e) {
      e.preventDefault();
      const allLayout = clone(this.props.allLayout);
      const find = findIndex(allLayout, { uid: this.props.uid });
      if (find !== -1) {
        const findSearchIndex = findIndex(allLayout[find].searchAttr, { uid: this.props.childUid });
        if (findSearchIndex !== -1) {
          allLayout[find].searchAttr[findSearchIndex] = Object.assign(allLayout[find].searchAttr[findSearchIndex], this.state.settings);
        }
      }
      const pushLayout = {
        allLayout,
        'shortcodeKey': this.props.shortcodeKey,
      };
      BuildActions.saveAllBlocks(pushLayout);
      panelActions.togglePanel('', this.props.shortcodeKey);
    }
    render() {
      return (<div>
        <button className="layout-save-button" onClick={this.saveData}><i className="fa fa-floppy-o"></i><span>Save</span></button>
        <div className="reactive-tab-setting">
          <ul className="nav nav-tabs" role="tablist">
            <li role="presentation" className="active"><a href="#appearance" aria-controls="general" role="tab" data-toggle="tab">Appearance</a></li>
          </ul>
          <div className="tab-content">
            <div role="tabpanel" className="tab-pane active" id="appearance">
              <input type="text" className="reactive-input" value= {stringify(this.state.settings.buttontitle)} onChange= { this.handelButtonTitle.bind(this) } placeholder={API.LANG.PLACE_BUTTON_TEXT}/>
              <input type="text" className="reactive-input" value= {this.state.settings.buttonstyle} onChange= { this.handelButtonStyle.bind(this) } placeholder={API.LANG.PLACE_BUTTON_STYLE}/>
              <input type="text" className="reactive-input" value= {this.state.settings.dynamicNameClassScrollBox} onChange= { this.handleClassName.bind(this) } placeholder={API.LANG.PLACE_CUSTOM_CSS}/>
            </div>
          </div>
        </div>

      </div>);
    }
}


ResetButtonPanel.propTypes = {
  'shortcodeKey': React.PropTypes.number,
  'uid': React.PropTypes.string,
  'childUid': React.PropTypes.string,
  'allLayout': React.PropTypes.array,
  'settings': React.PropTypes.object,
};

export default ResetButtonPanel;



// WEBPACK FOOTER //
// ./assets/src/frontend/panel/search/resetbuttonPanel.js